var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ValidationObserver", {
        ref: "form",
        attrs: { disabled: true, slim: "" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ handleSubmit, errors }) {
              return [
                _c(
                  "form",
                  {
                    staticClass: "form-horizontal",
                    attrs: { role: "form" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return handleSubmit(_vm.addValue)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "m-b-15" }, [
                      _c(
                        "div",
                        { staticClass: "display-flex flex--align-center" },
                        [
                          _c("ValidationProvider", {
                            ref: "txtKey",
                            attrs: {
                              vid: "txtKey",
                              rules: "required",
                              slim: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ classes }) {
                                    return [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.input.key,
                                            expression: "input.key"
                                          }
                                        ],
                                        ref: "keyEl",
                                        staticClass:
                                          "http-header__input form-control m-b-0",
                                        class: classes,
                                        attrs: {
                                          id: "key",
                                          name: "txtKey",
                                          autocomplete: "off",
                                          placeholder: "key"
                                        },
                                        domProps: { value: _vm.input.key },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.input,
                                              "key",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "http-header__separator m-l-10 m-r-10"
                            },
                            [_vm._v("\n            :\n          ")]
                          ),
                          _vm._v(" "),
                          _c("ValidationProvider", {
                            ref: "txtValue",
                            attrs: {
                              vid: "txtValue",
                              rules: "required",
                              slim: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function({ classes }) {
                                    return [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.input.value,
                                            expression: "input.value"
                                          }
                                        ],
                                        ref: "valueEl",
                                        staticClass:
                                          "http-header__input form-control m-b-0",
                                        class: classes,
                                        attrs: {
                                          id: "value",
                                          name: "txtValue",
                                          autocomplete: "off",
                                          placeholder: "value"
                                        },
                                        domProps: { value: _vm.input.value },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.input,
                                              "value",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          }),
                          _vm._v(" "),
                          _vm.enableMacros
                            ? [
                                _c("button", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "TOKEN",
                                      expression: "'TOKEN'"
                                    }
                                  ],
                                  ref: _vm.tokenButtonHeaderValue,
                                  staticClass: "btn btn-secondary",
                                  attrs: {
                                    id: _vm.tokenButtonHeaderValue,
                                    type: "button"
                                  },
                                  on: { click: _vm.toggleMacrosPopover }
                                }),
                                _vm._v(" "),
                                _c(
                                  "popover",
                                  {
                                    attrs: {
                                      "custom-class":
                                        "breakdown-legend__popover",
                                      placement: "bottom",
                                      trigger: "manual",
                                      target: "#" + _vm.tokenButtonHeaderValue
                                    },
                                    on: {
                                      show: function($event) {
                                        _vm.tagsPopoverVisible = true
                                      },
                                      hide: function($event) {
                                        _vm.tagsPopoverVisible = false
                                      }
                                    },
                                    model: {
                                      value: _vm.showMacrosPopover,
                                      callback: function($$v) {
                                        _vm.showMacrosPopover = $$v
                                      },
                                      expression: "showMacrosPopover"
                                    }
                                  },
                                  [
                                    _c(
                                      "template",
                                      { slot: "popover" },
                                      [
                                        _c("MacroSelectionPopover", {
                                          attrs: {
                                            "focus-dropdown":
                                              _vm.tagsPopoverVisible,
                                            "trigger-element":
                                              _vm.$refs[
                                                _vm.tokenButtonHeaderValue
                                              ],
                                            macros: _vm.macros
                                          },
                                          on: {
                                            blur: function($event) {
                                              _vm.showMacrosPopover = false
                                            },
                                            "selected-tag": _vm.onSelectedTag
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  2
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("button", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "ADD",
                                expression: "'ADD'"
                              }
                            ],
                            staticClass: "btn btn-success btn-sm m-l-15",
                            attrs: { type: "submit" }
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.showErrorMessage(errors)
                        ? _c("label", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "KEY_VALUE_REQUIRED",
                                expression: "'KEY_VALUE_REQUIRED'"
                              }
                            ],
                            staticClass: "form-group__label-error-message"
                          })
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("table", { staticClass: "table_beauty" }, [
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.valueColumns, function(col, index) {
                            return _c("tr", { key: index }, [
                              _c("td", { staticClass: "word-break-all" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(col.key) +
                                    " : " +
                                    _vm._s(col.value) +
                                    "\n            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _c(
                                  "div",
                                  { staticClass: "action-icon text-right" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "btn btn-list-function",
                                        on: {
                                          click: function($event) {
                                            return _vm.remove(col.key)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip.bottom.hover",
                                              value: _vm.$t("DELETE"),
                                              expression: "$t('DELETE')",
                                              modifiers: {
                                                bottom: true,
                                                hover: true
                                              }
                                            }
                                          ],
                                          staticClass: "fa fa-trash",
                                          attrs: { "aria-hidden": "true" }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          }),
                          _vm._v(" "),
                          _vm.valueColumns.length == 0
                            ? _c("tr", [
                                _c("td", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "NO_HEADERS",
                                      expression: "'NO_HEADERS'"
                                    }
                                  ],
                                  attrs: { colspan: "100%" }
                                })
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }